import { createContext, useContext, useState, ReactNode } from "react";

interface ShareholderContextType {
  shareholderName: string | null;
  shareholderId: string | null;
  setShareholderInfo: (info: { shareholderName: string | null; shareholderId: string | null }) => void;
}

const ShareholderContext = createContext<ShareholderContextType>({
  shareholderName: null,
  shareholderId: null,
  setShareholderInfo: () => {},
});

export const ShareholderProvider = ({ children }: { children: ReactNode }) => {
  const [shareholderName, setShareholderName] = useState<string | null>(null);
  const [shareholderId, setShareholderId] = useState<string | null>(null);

  const setShareholderInfo = ({ shareholderName, shareholderId }: { shareholderName: string | null; shareholderId: string | null }) => {
    setShareholderName(shareholderName);
    setShareholderId(shareholderId);
  };

  return (
    <ShareholderContext.Provider value={{ shareholderName, shareholderId, setShareholderInfo }}>
      {children}
    </ShareholderContext.Provider>
  );
};

export const useShareholderContext = () => useContext(ShareholderContext);